import './App1.css';
import logo from './images/LOGO.svg';
import bell from './images/notification.svg';
import React, { useState } from 'react';
import Stack from 'react-bootstrap/Stack';
import Accordion from 'react-bootstrap/Accordion';
import { Viewer } from '@react-pdf-viewer/core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExpand } from '@fortawesome/free-solid-svg-icons';
import '@react-pdf-viewer/core/lib/styles/index.css';
import { Worker } from '@react-pdf-viewer/core';
import '@react-pdf-viewer/core/lib/styles/index.css';
import { defaultLayoutPlugin } from '@react-pdf-viewer/default-layout';
import '@react-pdf-viewer/default-layout/lib/styles/index.css';
import { Card ,Button,Modal} from 'react-bootstrap'; // Import Card component for styling the accordion items
import mic from './images/mic.svg';
import axios from 'axios';
import upload from './images/upload.svg';
import chatnew from './images/edit.svg';
import send from './images/paper-plane.svg';
import users from './images/Users.svg';
import bot from './images/botMes.svg'
import user from './images/userMes.svg'
import chatIcon from './images/comment.svg';
import libraryIcon from './images/folder.svg';
import vector from './images/Vector.svg';
import flash from './images/flash.svg';
import 'bootstrap/dist/css/bootstrap.min.css';

function App1() {
  const [selectedKey, setSelectedKey] = useState(null);
  const [showLoader, setShowLoader] = useState(false);
  const [message, setText] = useState('');
  const [showRegenerateButton, setShowRegenerateButton] = useState(false);
  const [indexxx, setindex] = useState('');
  const [chatMessages, setChatMessages] = useState([]);
  const [previousQuestion, setPreviousQuestion] = useState('');
  const initialScale = 40;
  const newPlugin = defaultLayoutPlugin()
  const [image, setImage] = useState('');
  const [recommendedQuestions, setQuestions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [pdfData1, setPdfData1] = useState(null);
  const [pdfData, setPdfData] = useState('');
  const [showPdfPopup, setShowPdfPopup] = useState(false);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [fileuploaded, setfileuploaded] = useState(false);
  const [fileuploading, setfileuploading] = useState(false);
  const [firstQuestionSent, setFirstQuestionSent] = useState(false);
  const [activeTab, setActiveTab] = useState('chat');
  const [showModal, setShowModal] = useState(false);
    const [modalImage, setModalImage] = useState(null);

    const handleShowModal = (image) => {
        setModalImage(image);
        setShowModal(true);
    };

    const handleCloseModal = () => {
        setShowModal(false);
        setModalImage(null);
    };

  const dictionary = {
    1: 'Implement a Centralized Knowledge Repository',
    2: 'Promote Knowledge Sharing and Collaboration',
    3: 'Utilize Technology for Data Analysis and Decision Support',
    4: 'Establish Knowledge Capture Processes'
  };
  
  // Example state to manage expanded content
  const [expandedIndex, setExpandedIndex] = useState(null);
  const [expandedType, setExpandedType] = useState(null);
  const [pdfSources, setPdfSources] = useState([]);
  const [recommendations, setRecommendations] = useState([]);
  
  
  function formatMessage(message) {
    const lines = message.split("\n");
    return (
      <div style={{ paddingLeft: '10px', fontSize: '12px' }}>
        {lines.map((line, index) => (
          <div key={index}>{line}</div>
        ))}
      </div>
    );
  }


  
  const handleButtonClick1 = async (path) => {
    try {
      setShowPdfPopup(true)
      await fetch('http://57.153.102.63:5000/get-pdf', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ filepath: path }),
      })
        .then(res => res.blob())
        .then(blob => {
          const reader = new FileReader();
          console.log("qqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqq",showPdfPopup)
          reader.onload = () => {
            setPdfData1(reader.result);
            setLoading(false);
          };
          console.log(reader.result)
          reader.readAsDataURL(blob);
      
        });
    } catch (error) {
      console.error('Error loading PDF:', error);
    }
  };
  function formatMessage(message) {
    const lines = message.split("\n");
    return (
      <div style={{ padding: '5px', fontSize: '10px',textAlign:'left',marginLeft:'0%',font:'Graphik' }}>
        {lines.map((line, index) => (
          <div key={index}>{line}</div>
        ))}
      </div>
    );
  }
  const Loading = () => {
    return (
      <div style={{ marginLeft: '40%' }} className="loader-sv">
        <div className="dot-cq-sv red-c-sv"></div>
        <div className="dot-cq-sv green-c-sv"></div>
        <div className="dot-cq-sv blue-c-sv"></div>
      </div>
    );
  };
  
  const handleSendButtonClick = () => {
    handleSendMessage();
    setText('');
    setFirstQuestionSent(true);
  };
  const [position, setPosition] = useState({ x: 100, y: 100 });
  const [dragging, setDragging] = useState(false);
  const [offset, setOffset] = useState({ x: 0, y: 0 });

  const handleMouseDown = (e) => {
    setDragging(true);
    setOffset({
      x: e.clientX - position.x,
      y: e.clientY - position.y,
    });
  };

  const handleMouseMove = (e) => {
    if (dragging) {
      setPosition({
        x: e.clientX - offset.x,
        y: e.clientY - offset.y,
      });
    }
  };

  const handleMouseUp = () => {
    setDragging(false);
  };
  const handleSendMessage1 = () => {
    if (message.trim() !== '') {
      handleSendMessage(message);
      setText('');
    }
  };
  const handleQuestionSelect = (question) => {
    // Set the selected question and send it as the next message
   
    setText(question);
    handleSendMessage1();
   
  };
  const handleSendMessage = async () => {
    try {
      setChatMessages((prevMessages) => [...prevMessages, { user: true, message, recommendation: false, init: true }]);
      setShowLoader(true);
      const json = {
        message: message
      };
      const response = await axios.post('http://57.153.102.63:5000/chatBot', json);
      console.log('Chatbot API response:', response.data);
      const chatbotResponse = response.data.response === null
        ? "Unable to answer your query. Please try again.."
        : response.data.response;
      console.log('Chatbot response:', chatbotResponse);
      const pdfData = chatbotResponse;
      console.log("aaaaaaaaaaaaaaa", pdfData.source);
      setPdfData(pdfData);
      setQuestions(response.data.folderQuest);
      console.log("qqqqqqqqqqqqqqqqqqqwwwwwwwwwwwww", response.data.folderQuest);
      pdfData.source.map(
        (pdf, index) => (
          console.log("kk", pdf)
        )
      );
      const botMessage = { user: false, message: chatbotResponse['answer'], source: chatbotResponse['source'], image: response.data.image, table: response.data.table };
      setChatMessages((prevMessages) => [...prevMessages, botMessage]);
      setShowLoader(false);
      setImage(response.data.image);
      setPreviousQuestion(message);
      setShowRegenerateButton(true); 
      console.log("aaaaaaaaaa", showRegenerateButton);
    } catch (error) {
      console.error(error);
      const botMessage = { user: false, message: 'Failed to Get the response.', recommendation: false, init: true };
      setChatMessages((prevMessages) => [...prevMessages, botMessage]);
    }
  };
  const handleClose = () => {
    setShowPdfPopup(false);
  };
  const handleFileChange = async (e) => {
    const selectedFiles_var = Array.from(e.target.files);
    console.log(selectedFiles_var);
    setSelectedFiles(selectedFiles_var);
    await handleUpload(selectedFiles_var);
    // setfileuploaded(true);
  };
  const handleUpload = async (selectedFiles_var) => {
    if (selectedFiles_var) {
      try {
        const formData = new FormData();
        selectedFiles_var.forEach((file, index) => {
          console.log(index)
          formData.append(`file`, file);
        });
        console.log(selectedFiles_var);
        setfileuploading(true);
        const response = await axios.post('http://57.153.102.63:5000/uploadFiles', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        });
        console.log('API response:', response.data);
        // const upload_response = response.data;
        // seUploadresponse(upload_response);
        setfileuploading(false);
        if (response.data === "file loaded successfully") {
          console.log('File uploaded successfully!')
          setfileuploaded(true);
          setTimeout(() => {
            setfileuploaded(false);
        }, 2000);
        } else {
          console.error('File upload failed.');
          alert('File upload failed.');
        }
      }
      catch (error) {
        console.log(error)
      }
    } else {
      alert('Please select a file to upload.');
    }
  };
  return (
    <div className="App" style={{ backgroundColor: '#2B2C33', height: '100vh', width: '100%' }}>
      {showLoader ? <Loading /> : null}
      <Modal show={showModal} onHide={handleCloseModal} centered size="lg">
        
                <Modal.Header closeButton>
                    <Modal.Title>Image</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {modalImage && <img src={modalImage} alt="Full Screen" style={{ width: '100%' }} />}
                </Modal.Body>
                
            </Modal>
      {showPdfPopup && (
        <div
          className="popup-overlay"
          onMouseMove={handleMouseMove}
          onMouseUp={handleMouseUp}
        >
          <div
            className="popup-container"
            style={{ top: `${position.y}px`, left: `${position.x}px` }}
            onMouseDown={handleMouseDown}
          >
            <button className="close-button" onClick={handleClose}>
              &times;
            </button>
           
            <div className='top-part-chart-chatbot'></div>
            {!loading && (
              <div className="pdf-viewer">
                <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.11.174/build/pdf.worker.min.js">
                  <Viewer fileUrl={pdfData1} plugins={[newPlugin]} scale={initialScale} />
                </Worker>
              </div>
            )}
          </div>
        </div>
      )}
      <div style={{ height: '97vh' }}>
        <div className='row' style={{ background: 'linear-gradient(to bottom, rgba(19, 22, 25, 0) 0%, rgba(19, 22, 25, 1) 100%)', height: '7vh', width: '100.9%' }}>
          <div className='col-sm-7' style={{ margin: '5px', marginLeft: '20px', display: 'flex', flexDirection: 'row' }}>
            <img src={logo} alt="Logo" />
            <div style={{ color: 'white', marginLeft: '10px', fontWeight: '600', fontStyle: 'graphik', fontSize: '17px' }}>Oil & Gas Trading Knowledge Management</div>
          </div>
        </div>
       
        {firstQuestionSent ? (
          <div>
            <div className='row' style={{ borderBottom: '0.92px solid #4E4E4E', height: '9vh', marginLeft: '70px', marginRight: '70px' }}>
              <div className='col-sm-10'>
                <div style={{display:'flex', flexDirection:'row', backgroundColor:'rgba(26, 29, 33, 1)', borderRadius:'7px', width:'10%', marginTop:'12px', height:'30px'}}>
                  <img src={chatnew} style={{width:'15%', marginLeft:'10px'}} alt="New Chat"/>
                  <div style={{marginTop:'5px', marginLeft:'5px', fontSize:'12px', color:'white'}}>New chat</div>
                </div>
              </div>
              <div className='col-sm-2' style={{ marginTop: '8px' }}>
                <img src={bell} alt="Bell" style={{ marginRight: '10px', marginLeft: '50%' }} />
                <img src={users} alt="User" />
              </div>
            </div>
            
            <div style={{ display: 'flex', justifyContent: 'center', marginTop: '10px',color:' rgba(155, 156, 158, 1)' ,height:'30px',fontSize:'12px'}}>
            
              <div onClick={() => setActiveTab('chat')} style={{ display: 'flex', alignItems: 'center', marginRight: '10px',borderBottom: activeTab === 'chat' ? '2px solid transparent' : 'none', borderImage: activeTab === 'chat' ? 'linear-gradient(to right, rgba(246, 106, 75, 1) 0%, rgba(246, 106, 75, 1) 30%, rgba(162, 74, 231, 1) 60%, rgba(72, 89, 243, 1) 100%) 1' : 'none', borderImageSlice: 1 }}>
              <img src={chatIcon} alt="Chat Icon" style={{ marginRight: '5px' }} />
                Chat
                </div> 
              <div onClick={() => setActiveTab('library')} style={{ display: 'flex', alignItems: 'center', borderBottom: activeTab === 'library' ? '2px solid transparent' : 'none', borderImage: activeTab === 'library' ? 'linear-gradient(to right, rgba(246, 106, 75, 1) 0%, rgba(246, 106, 75, 1) 30%, rgba(162, 74, 231, 1) 60%, rgba(72, 89, 243, 1) 100%) 1' : 'none', borderImageSlice: 1 }}>
                <img src={libraryIcon} alt="Library Icon" style={{ marginRight: '-5px',marginTop:'16px' }} />
                Library
              </div>
            </div>
            <div style={{ color: 'white', textAlign: 'center', marginTop: '20px' }}>
              {activeTab === 'chat' ? (
                <div>
               <Stack direction="vertical" gap={1}  style={{ height: '57vh', overflowY: 'scroll',marginLeft: '6%' }}>
            
                 {chatMessages.map((message, index) => (
                  <div style={{ borderBottom: message.user ? 'none' : '1px solid rgba(161, 161, 161, 1)', paddingBottom: message.user ? '0' : '10px',display:'flex',flexDirection:'row'}}>
                    <div style={{width:'65%'}}>
                    <div key={index} className="row" style={{ marginLeft: '2%', paddingBottom: message.user ? '0' : '10px' }}>
            {message.user ? (
              <div>
                <div className="row" style={{ marginTop: '1%', border: '1px solid #4E4E4E', borderRadius: '10px', paddingTop: '1%' }}>
                  <div className="col-sm-2" style={{ display: 'flex', flexDirection: 'row' }}>
                    <img style={{ width: '20%' }} src={user} alt="User" />
                    <div style={{ marginLeft: '5%', color: 'rgba(155, 156, 158, 1)', fontSize: '12px', marginTop: '5px' }}>You</div>
                  </div>
                  <div className="col-sm-10">
                    <div style={{ padding: '5px', fontSize: '10px', textAlign: 'left', font: 'Graphik' }}>
                      {message.message}
                    </div>
                  </div>
                </div>
              </div>
            ) : (
              <div>
                <div className="row" style={{ marginTop: '1%', border: '1px solid #4E4E4E', borderRadius: '10px', paddingTop: '1%' }}>
                  <div className="col-sm-2" style={{ display: 'flex', flexDirection: 'row' }}>
                    <img style={{ width: '20%' }} src={bot} alt="Bot" />
                    <div style={{ marginLeft: '5%', color: 'rgba(155, 156, 158, 1)', fontSize: '12px', marginTop: '5px' }}>Chatbot</div>
                  </div>
                  <div className="col-sm-10">
                    <div style={{ padding: '5px', fontSize: '10px', textAlign: 'left', marginLeft: '2.5%', font: 'Graphik' }}>
                      {formatMessage(message.message)}
                    </div>
                  </div>
                </div>
              </div>
            )}
            
            </div>
                    </div>
                    <div style={{width:'30%'}}>
                    {message.user ?null: (
        <div style={{marginTop:'-40px',maxHeight:'30vh',overflowY:'scroll'}}>
  
  <Accordion className="metdata-accordian-ria" id="accordionExample1" >
                                        <Accordion.Item className="custom-body-sop">
                                            <Accordion.Header className="custom-accordion-header-sop" style={{fontSize: '10px', textAlign: 'left', font: 'Graphik' }}>
                                              <div  style={{ fontSize: '10px', textAlign: 'center', font: 'Graphik' }}>
                                                Image
                                                </div>
                                            </Accordion.Header>
                                            <Accordion.Body className="custom-accordion-body-sop">
                                                {message.image && (
                                                    <div >
                                                    <Button style={{background:'none',border:'none',marginLeft:'250px'}} onClick={() => handleShowModal(message.image)}>
                                                        <FontAwesomeIcon icon={faExpand} />
                                                        </Button>
                                                        <Card.Img src={message.image} alt="Image" />
                                                        
                                                    </div>
                                                )}
                                            </Accordion.Body>
                                        </Accordion.Item>
                                    </Accordion>
                          <Accordion className="metdata-accordian-ria" id="accordionExample1">
                        
                          <Accordion.Item key={index} className="custom-body-sop">
                            <Accordion.Header className="custom-accordion-header-sop" style={{ fontSize: '10px', textAlign: 'left',  font: 'Graphik' }}>
                            <div  style={{ fontSize: '10px', textAlign: 'center', font: 'Graphik' }}>
                            Documents
                            </div>
                            </Accordion.Header>
                            <Accordion.Body className="custom-accordion-body-sop">
                            {pdfData&&(pdfData.source.map((pdf, index) => (
                              <div style={{fontSize:'10px'}}>
                              
                              {/* Assuming handleButtonClick1 accepts a filepath as an argument */}
                              <button style={{
    background: 'linear-gradient(to right, rgba(246, 106, 75, 1) 0%, rgba(246, 106, 75, 1) 30%, rgba(162, 74, 231, 1) 60%, rgba(72, 89, 243, 1) 100%)',
    fontSize: '10px',
    border: '1px solid rgb(26, 29, 33)',
    borderRadius: '15px',
    color: 'white',
    margin: '2px',
    padding: '5px 10px', // Adjust padding as needed
    cursor: 'pointer' // Add cursor pointer for interaction
  }} onClick={() => handleButtonClick1(pdf.filepath)}>
                              {pdf.filename}
                              </button>
                              </div>
                            ))
                          )}
                            </Accordion.Body>
                          </Accordion.Item>
                      

                      </Accordion>
                      <Accordion className="metdata-accordian-ria" id="accordionExample1">
                        
                        <Accordion.Item key={index} className="custom-body-sop">
                          <Accordion.Header className="custom-accordion-header-sop">
                          <div  style={{fontSize: '10px', textAlign: 'left',  font: 'Graphik' }}>
                          recommendations
                          </div>
                          </Accordion.Header>
                          <Accordion.Body className="custom-accordion-body-sop">
                          {recommendedQuestions.map((question, index) => (
                                      <div style={{fontSize:'10px'}} key={index}>
                                          {question.split('?').map((part, i) => (
                                              <span key={i}  onClick={() => {
                                                handleQuestionSelect(part)
                                              }}>
                                                  {part}{i === 0 ? '?' : ''}<br />
                                              </span>
                                          ))}
                                      </div>
                                  ))}
                          </Accordion.Body>
                        </Accordion.Item>


                      </Accordion>
                      </div>
                      )}
                    </div>
                  </div>
                 ))}
             
              </Stack>
              <div className='row' style={{ backgroundColor: 'white', height: '45px', width: '60%', borderRadius: '18px', border: '1px solid white', marginLeft: '6%', marginTop: '20px', display: 'flex', flexDirection: 'row' }}>
      <img style={{ width: '5%', marginTop: '0px' }} src={mic} alt="Mic" />
      <textarea
        style={{ width: '78%', height: '44px', paddingTop: '7px', border: 'none', outline: 'none', resize: 'none' }}
        value={message}
        onChange={(e) => setText(e.target.value)}
        placeholder="What is in your mind?"
      />
       
       <label htmlFor="fileInput" style={{width:'10%'}}>
  <img style={{ width: '30%',marginTop:'15px', cursor: 'pointer' }} src={upload} alt="Upload" />
</label>
<input
  id="fileInput"
  type="file"
  multiple
  onChange={handleFileChange}
  accept=".pdf"
  style={{ display: 'none' }}
/>

   
      <img style={{ width: '5%', height: '30px', marginTop: '7px', cursor: 'pointer', backgroundColor: 'rgba(161, 0, 255, 1)', borderRadius: '20px' }} src={send} alt="Send" onClick={handleSendButtonClick} />
    </div>
    </div>
              ) : (
                <div>Library Content</div>
              )}
            </div>
          </div>

        ) : (
          <>
           <div className='row' style={{ borderBottom: '0.92px solid #4E4E4E', height: '9vh', marginLeft: '70px', marginRight: '70px' }}>
              <div className='col-sm-10'></div>
              <div className='col-sm-2' style={{ marginTop: '8px' }}>
                <img src={bell} alt="Bell" style={{ marginRight: '10px', marginLeft: '50%' }} />
                <img src={users} alt="User" />
              </div>
            </div>
            <div className='gradient-text' style={{ marginTop: '3%' }}>Oil & Gas Trading</div>
            <div className='gradient-text'>Knowledge Management</div>
            <div style={{ color: 'rgba(255, 255, 255, 0.64)', fontFamily: 'Graphik', fontSize: '15px', textAlign: 'center', marginTop: '10px' }}>Optimize oil & gas trading strategies with efficient knowledge management</div>
            <div className='row' style={{ backgroundColor: 'white', height: '45px', width: '50%', borderRadius: '18px', border: '1px solid white', marginLeft: '25%', marginTop: '20px', display: 'flex', flexDirection: 'row' }}>
              <img style={{ width: '6%', marginTop: '0px' }} src={mic} alt="Mic" />
              <textarea
                style={{ width: '75%', height: '44px', paddingTop: '7px', border: 'none', outline: 'none', resize: 'none' }}
                value={message}
                onChange={(e) => setText(e.target.value)}
                placeholder="What is in your mind?"
              />
               <label htmlFor="fileInput" style={{width:'10%'}}>
  <img style={{ width: '30%',marginTop:'15px', cursor: 'pointer' ,marginLeft:'20px'}} src={upload} alt="Upload" />
</label>
<input
  id="fileInput"
  type="file"
  multiple
  onChange={handleFileChange}
  accept=".pdf"
  style={{ display: 'none' }}
/>
              <img style={{ width: '6%', height: '30px', marginTop: '7px', cursor: 'pointer', backgroundColor: 'rgba(161, 0, 255, 1)', borderRadius: '20px' }} src={send} alt="Send" onClick={handleSendButtonClick} />
            </div>
            <div style={{ color: 'rgba(255, 255, 255, 0.32)', fontFamily: 'Graphik', fontSize: '15px', textAlign: 'center', marginTop: '10px' }}>You may ask</div>
            <div style={{ marginLeft: '25%' }}>
              <div className="box_qest">
                {Object.entries(dictionary).map(([key, value]) => (
                  <div
                    key={key}
                    className={`box ${selectedKey === key ? 'selected' : ''}`}
                    onClick={() => setSelectedKey(key)}
                  >
                    <img
                      style={{
                        width: '15%',
                        marginTop: '20px',
                        backgroundColor: 'rgba(255, 255, 255, 0.06)',
                        borderRadius: '5px',
                        border: '1px solid rgba(255, 255, 255, 0.06)',
                        padding: '3px'
                      }}
                      src={vector}
                      alt="vector"
                    />
                    {value}
                    <div style={{ display: 'flex', flexDirection: 'row' }}>
                      <div style={{ color: 'rgba(255, 255, 255, 0.32)', borderBottom: '1px solid rgba(255, 255, 255, 0.32)' }}>
                        Ask this
                      </div>
                      <img
                        style={{ width: '5%', marginLeft: '5px' }}
                        src={flash}
                        alt="flash"
                      />
                    </div>
                  </div>
                ))}
              </div>
            </div>
            
           
          </>
        )}
      </div>
      <div style={{ color: 'rgba(255, 255, 255, 0.48)', textAlign: 'center', fontSize: '10px', backgroundColor: 'rgba(35, 36, 42, 1)' }}>Copyright © 2024</div>
    </div>
  );
}

export default App1;
